// src/components/BoardOfEd/components/Program2000.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_2000_CONFIG = {
  fullName: "MUSIC",
  docId: "2000",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Administrative" },
        { block: "Positions", key: "ADMINISTRATIVE" },
      ],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [
        { block: "Positions", key: "Teachers" },
        { block: "Positions", key: "TEACHERS" },
      ],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Administrative" },
        { block: "Salaries", key: "ADMINISTRATIVE" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Teachers" },
        { block: "Salaries", key: "TEACHERS" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [
        // Most years
        { block: "Purchased Services", key: "Field Trips" },
        { block: "Purchased Services", key: "FIELD TRIPS" },

        // Some years (e.g., 2012 Actual, 2015 Actual, 2023 Actual, 2024 Actual)
        { block: "Salaries", key: "Field Trips" },
        { block: "Salaries", key: "FIELD TRIPS" },
      ],
      // you currently group this under salaries; keeping that so it shows with salary-ish lines
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "guestConductors",
      label: "Guest Conductors",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Guest Conductors" },
        { block: "Purchased Services", key: "GUEST CONDUCTORS" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "artInResidence",
      label: "Art in Residence",
      valueType: "currency",
      sources: [
        // you have both spellings in your data set
        { block: "Purchased Services", key: "Art in Residence" },
        { block: "Purchased Services", key: "Artist in Residence" },
        { block: "Purchased Services", key: "ART IN RESIDENCE" },
        { block: "Purchased Services", key: "ARTIST IN RESIDENCE" },
      ],
      group: "services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology - Software" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "entranceFeesDues",
      label: "Entrance Fees / Dues",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Entrance Fees / Dues" },
        { block: "Other", key: "Entrance Fees/Dues" },
        { block: "Other", key: "ENTRANCE FEES / DUES" },
      ],
      group: "other",
      defaultVisible: false,
    },

    // EQUIPMENT
    {
      key: "equipmentNew",
      label: "Equipment – New",
      valueType: "currency",
      sources: [
        { block: "Equipment", key: "New" },
        { block: "Equipment", key: "NEW" },
      ],
      group: "equipment",
      defaultVisible: false,
    },
    {
      key: "equipmentReplacement",
      label: "Equipment – Replacement",
      valueType: "currency",
      sources: [
        { block: "Equipment", key: "Replacement" },
        { block: "Equipment", key: "REPLACEMENT" },
      ],
      group: "equipment",
      defaultVisible: false,
    },
  ],

  tables: [
    // ---------- APPROVED (single table) ----------
    {
      id: "approved",
      title: "2000 MUSIC – Approved",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "fieldTrips",
        "guestConductors",
        "artInResidence",
        "instructionalMaterials",
        "technologySoftware",
        "entranceFeesDues",
        "equipmentNew",
        "equipmentReplacement",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesTeachers: { minWidth: "110px" },

        // Purchased Services
        fieldTrips: { minWidth: "90px" },
        guestConductors: { minWidth: "90px" },
        artInResidence: { minWidth: "90px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "110px" },
        technologySoftware: { minWidth: "110px" },
        entranceFeesDues: { minWidth: "110px" },

        // Equipment
        equipmentNew: { minWidth: "110px" },
        equipmentReplacement: { minWidth: "110px" },
      },
    },

    // ---------- ACTUAL (single table) ----------
    {
      id: "actual",
      title: "2000 MUSIC – Actual",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "fieldTrips",
        "guestConductors",
        "artInResidence",
        "instructionalMaterials",
        "technologySoftware",
        "entranceFeesDues",
        "equipmentNew",
        "equipmentReplacement",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesTeachers: { minWidth: "110px" },

        // Purchased Services
        fieldTrips: { minWidth: "90px" },
        guestConductors: { minWidth: "90px" },
        artInResidence: { minWidth: "90px" },

        // Materials / Other
        instructionalMaterials: { minWidth: "110px" },
        technologySoftware: { minWidth: "110px" },
        entranceFeesDues: { minWidth: "110px" },

        // Equipment
        equipmentNew: { minWidth: "110px" },
        equipmentReplacement: { minWidth: "110px" },
      },
    },
  ],

  inflationSumFields: null,
};

export function Program2000(props) {
  return (
    <ProgramBudget programId="2000" config={PROGRAM_2000_CONFIG} {...props} />
  );
}
